/** @format */

export enum PlkCommandEnum {
    GETACCOUNTFORSUBSCRIPTION = 'getaccountforsubscription',
    GETADJUSTMENTHISTORYFORSUBSCRIPTION = 'getAdjustmentHistoryForSubscription',
    GETCHARGEHISTORYFORSUBSCRIPTION = 'getChargeHistoryForSubscription',
    GETCURRENCYBALANCEFORSUBSCRIPTION = 'getCurrencyBalanceForSubscription',
    GETCUSTOMERFORSUBSCRIPTION = 'getCustomerForSubscription',
    GETCUSTOMERINTERACTIONSFORSUBSCRIPTION = 'getCustomerInteractionsForSubscription',
    GETFAFHISTORYFORSUBSCRIPTION = 'getFaFHistoryForSubscription',
    GETFAFNUMBERSFORSUBSCRIPTION = 'getFaFNumbersForSubscription',
    GETFEATUREDETAILSFORSUBSCRIPTION = 'getFeatureDetailsForSubscription',
    GETFEATURESFORSUBSCRIPTION = 'getFeaturesForSubscription',
    GETFEATUREUSAGEFORSUBSCRIPTION = 'getFeatureUsageForSubscription',
    GETRELOADHISTORYFORSUBSCRIPTION = 'getReloadHistoryForSubscription',
    GETSIMCARDFORSUBSCRIPTION = 'getSimCardForSubscription',
    GETSUBSCRIPTION = 'getSubscription',
    GETVOICEMAILFORSUBSCRIPTION = 'getVoiceMailForSubscription',

    CLIENTSUBSCRACTIVATESUBSCR = 'ClientSubscrActivateSubscr',
    CLIENTSUBSCRACTIVATEVOICEMAIL = 'ClientSubscrActivateVoicemail',
    CLIENTSUBSCRADDFAFNUMBER = 'ClientSubscrAddFaFNumber',
    CLIENTSUBSCRADDPACKAGE = 'ClientSubscrAddPackage',
    CLIENTSUBSCRCHANGEAPN = 'ClientSubscrChangeApn',
    CLIENTSUBSCRCHANGEGPRS = 'ClientSubscrChangeGPRS',
    CLIENTSUBSCRCHANGEMSISDN = 'ClientSubscrChangeMsisdn',
    CLIENTSUBSCRCHANGENETWORKSERVICE = 'ClientSubscrChangeNetworkservice',
    CLIENTSUBSCRCHANGEPROMOTION = 'ClientSubscrChangePromotion',
    CLIENTSUBSCRCHANGEROAMING = 'ClientSubscrChangeRoaming',
    CLIENTSUBSCRCHANGESIMCARD = 'ClientSubscrChangeSimcard',
    CLIENTSUBSCRCHANGESTATUS = 'ClientSubscrChangeStatus',
    CLIENTSUBSCRCHANGETARIFF = 'ClientSubscrChangeTariff',
    CLIENTSUBSCRCONTRACTSET = 'ClientSubscrContractSet',
    CLIENTSUBSCRCREATEADJUSTMENT = 'ClientSubscrCreateAdjustment',
    CLIENTSUBSCRDELETEFAFNUMBER = 'ClientSubscrDeleteFaFNumber',
    CLIENTSUBSCRPREPAIDPORTINGSET = 'ClientSubscrPrepaidPortingSet',
    CLIENTSUBSCRRELOADACCOUNT = 'ClientSubscrReloadAccount',
    CLIENTSUBSCRREMOVEPACKAGE = 'ClientSubscrRemovePackage',
    CLIENTSUBSCRREMOVEVOICEMAIL = 'ClientSubscrRemoveVoicemail',
    CLIENTSUBSCRRESETVMPASSWORD = 'ClientSubscrResetVMPassword',
    CLIENTSUBSCRUPDATEBPR = 'ClientSubscrUpdateBpr',
    CLIENTSUBSCRUPDATECUSTOMER = 'ClientSubscrUpdateCustomer',
    CLIENTSUBSCRUPDATEDETAILS = 'ClientSubscrUpdateDetails',
}

export enum PlkCommandName {
    GETACCOUNTFORSUBSCRIPTION = 'getAccountForSubscription',
    GETADJUSTMENTHISTORYFORSUBSCRIPTION = 'getAdjustmentHistoryForSubscription',
    GETCHARGEHISTORYFORSUBSCRIPTION = 'getChargeHistoryForSubscription',
    GETCURRENCYBALANCEFORSUBSCRIPTION = 'getCurrencyBalanceForSubscription',
    GETCUSTOMERFORSUBSCRIPTION = 'getCustomerForSubscription',
    GETCUSTOMERINTERACTIONSFORSUBSCRIPTION = 'getCustomerInteractionsForSubscription',
    GETFAFHISTORYFORSUBSCRIPTION = 'getFaFHistoryForSubscription',
    GETFAFNUMBERSFORSUBSCRIPTION = 'getFaFNumbersForSubscription',
    GETFEATUREDETAILSFORSUBSCRIPTION = 'getFeatureDetailsForSubscription',
    GETFEATURESFORSUBSCRIPTION = 'getFeaturesForSubscription',
    GETFEATUREUSAGEFORSUBSCRIPTION = 'getFeatureUsageForSubscription',
    GETRELOADHISTORYFORSUBSCRIPTION = 'getReloadHistoryForSubscription',
    GETSIMCARDFORSUBSCRIPTION = 'getSimCardForSubscription',
    GETSUBSCRIPTION = 'getSubscription',
    GETVOICEMAILFORSUBSCRIPTION = 'getVoiceMailForSubscription',

    CLIENTSUBSCRACTIVATESUBSCR = 'ClientSubscrActivateSubscr',
    CLIENTSUBSCRACTIVATEVOICEMAIL = 'ClientSubscrActivateVoicemail',
    CLIENTSUBSCRADDFAFNUMBER = 'ClientSubscrAddFaFNumber',
    CLIENTSUBSCRADDPACKAGE = 'ClientSubscrAddPackage',
    CLIENTSUBSCRCHANGEAPN = 'ClientSubscrChangeApn',
    CLIENTSUBSCRCHANGEGPRS = 'ClientSubscrChangeGPRS',
    CLIENTSUBSCRCHANGEMSISDN = 'ClientSubscrChangeMsisdn',
    CLIENTSUBSCRCHANGENETWORKSERVICE = 'ClientSubscrChangeNetworkservice',
    CLIENTSUBSCRCHANGEPROMOTION = 'ClientSubscrChangePromotion',
    CLIENTSUBSCRCHANGEROAMING = 'ClientSubscrChangeRoaming',
    CLIENTSUBSCRCHANGESIMCARD = 'ClientSubscrChangeSimcard',
    CLIENTSUBSCRCHANGESTATUS = 'ClientSubscrChangeStatus',
    CLIENTSUBSCRCHANGETARIFF = 'ClientSubscrChangeTariff',
    CLIENTSUBSCRCONTRACTSET = 'ClientSubscrContractSet',
    CLIENTSUBSCRCREATEADJUSTMENT = 'ClientSubscrCreateAdjustment',
    CLIENTSUBSCRDELETEFAFNUMBER = 'ClientSubscrDeleteFaFNumber',
    CLIENTSUBSCRPREPAIDPORTINGSET = 'ClientSubscrPrepaidPortingSet',
    CLIENTSUBSCRRELOADACCOUNT = 'ClientSubscrReloadAccount',
    CLIENTSUBSCRREMOVEPACKAGE = 'ClientSubscrRemovePackage',
    CLIENTSUBSCRREMOVEVOICEMAIL = 'ClientSubscrRemoveVoicemail',
    CLIENTSUBSCRRESETVMPASSWORD = 'ClientSubscrResetVMPassword',
    CLIENTSUBSCRUPDATEBPR = 'ClientSubscrUpdateBpr',
    CLIENTSUBSCRUPDATECUSTOMER = 'ClientSubscrUpdateCustomer',
    CLIENTSUBSCRUPDATEDETAILS = 'ClientSubscrUpdateDetails',
}

export default class PlkCommand {
    static getList(): { value: string; name: string }[] {
        return [
            { value: PlkCommandEnum.GETACCOUNTFORSUBSCRIPTION, name: PlkCommandName.GETACCOUNTFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETADJUSTMENTHISTORYFORSUBSCRIPTION, name: PlkCommandName.GETADJUSTMENTHISTORYFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETCHARGEHISTORYFORSUBSCRIPTION, name: PlkCommandName.GETCHARGEHISTORYFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETCURRENCYBALANCEFORSUBSCRIPTION, name: PlkCommandName.GETCURRENCYBALANCEFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETCUSTOMERFORSUBSCRIPTION, name: PlkCommandName.GETCUSTOMERFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETCUSTOMERINTERACTIONSFORSUBSCRIPTION, name: PlkCommandName.GETCUSTOMERINTERACTIONSFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETFAFHISTORYFORSUBSCRIPTION, name: PlkCommandName.GETFAFHISTORYFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETFAFNUMBERSFORSUBSCRIPTION, name: PlkCommandName.GETFAFNUMBERSFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETFEATUREDETAILSFORSUBSCRIPTION, name: PlkCommandName.GETFEATUREDETAILSFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETFEATURESFORSUBSCRIPTION, name: PlkCommandName.GETFEATURESFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETFEATUREUSAGEFORSUBSCRIPTION, name: PlkCommandName.GETFEATUREUSAGEFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETRELOADHISTORYFORSUBSCRIPTION, name: PlkCommandName.GETRELOADHISTORYFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETSIMCARDFORSUBSCRIPTION, name: PlkCommandName.GETSIMCARDFORSUBSCRIPTION },
            { value: PlkCommandEnum.GETSUBSCRIPTION, name: PlkCommandName.GETSUBSCRIPTION },
            { value: PlkCommandEnum.GETVOICEMAILFORSUBSCRIPTION, name: PlkCommandName.GETVOICEMAILFORSUBSCRIPTION },

            { value: PlkCommandEnum.CLIENTSUBSCRACTIVATESUBSCR, name: PlkCommandName.CLIENTSUBSCRACTIVATESUBSCR },
            { value: PlkCommandEnum.CLIENTSUBSCRACTIVATEVOICEMAIL, name: PlkCommandName.CLIENTSUBSCRACTIVATEVOICEMAIL },
            { value: PlkCommandEnum.CLIENTSUBSCRADDFAFNUMBER, name: PlkCommandName.CLIENTSUBSCRADDFAFNUMBER },
            { value: PlkCommandEnum.CLIENTSUBSCRADDPACKAGE, name: PlkCommandName.CLIENTSUBSCRADDPACKAGE },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGEAPN, name: PlkCommandName.CLIENTSUBSCRCHANGEAPN },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGEGPRS, name: PlkCommandName.CLIENTSUBSCRCHANGEGPRS },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGEMSISDN, name: PlkCommandName.CLIENTSUBSCRCHANGEMSISDN },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGENETWORKSERVICE, name: PlkCommandName.CLIENTSUBSCRCHANGENETWORKSERVICE },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGEPROMOTION, name: PlkCommandName.CLIENTSUBSCRCHANGEPROMOTION },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGEROAMING, name: PlkCommandName.CLIENTSUBSCRCHANGEROAMING },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGESIMCARD, name: PlkCommandName.CLIENTSUBSCRCHANGESIMCARD },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGESTATUS, name: PlkCommandName.CLIENTSUBSCRCHANGESTATUS },
            { value: PlkCommandEnum.CLIENTSUBSCRCHANGETARIFF, name: PlkCommandName.CLIENTSUBSCRCHANGETARIFF },
            { value: PlkCommandEnum.CLIENTSUBSCRCONTRACTSET, name: PlkCommandName.CLIENTSUBSCRCONTRACTSET },
            { value: PlkCommandEnum.CLIENTSUBSCRCREATEADJUSTMENT, name: PlkCommandName.CLIENTSUBSCRCREATEADJUSTMENT },
            { value: PlkCommandEnum.CLIENTSUBSCRDELETEFAFNUMBER, name: PlkCommandName.CLIENTSUBSCRDELETEFAFNUMBER },
            { value: PlkCommandEnum.CLIENTSUBSCRPREPAIDPORTINGSET, name: PlkCommandName.CLIENTSUBSCRPREPAIDPORTINGSET },
            { value: PlkCommandEnum.CLIENTSUBSCRRELOADACCOUNT, name: PlkCommandName.CLIENTSUBSCRRELOADACCOUNT },
            { value: PlkCommandEnum.CLIENTSUBSCRREMOVEPACKAGE, name: PlkCommandName.CLIENTSUBSCRREMOVEPACKAGE },
            { value: PlkCommandEnum.CLIENTSUBSCRREMOVEVOICEMAIL, name: PlkCommandName.CLIENTSUBSCRREMOVEVOICEMAIL },
            { value: PlkCommandEnum.CLIENTSUBSCRRESETVMPASSWORD, name: PlkCommandName.CLIENTSUBSCRRESETVMPASSWORD },
            { value: PlkCommandEnum.CLIENTSUBSCRUPDATEBPR, name: PlkCommandName.CLIENTSUBSCRUPDATEBPR },
            { value: PlkCommandEnum.CLIENTSUBSCRUPDATECUSTOMER, name: PlkCommandName.CLIENTSUBSCRUPDATECUSTOMER },
            { value: PlkCommandEnum.CLIENTSUBSCRUPDATEDETAILS, name: PlkCommandName.CLIENTSUBSCRUPDATEDETAILS },
        ];
    }
}
